import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    InputField,
    BORDER_TYPES_PROP_TYPES,
    BORDER_SIMPLE,
    STYLES_PROP_TYPES,
} from '@eventbrite/legacy-eds.input-field';
import { CopyButtonWithTooltip } from '@eventbrite/legacy-eds.copy-button';

interface CopyFieldProps {
    inputFieldId: string;
    label: React.ReactNode;
    value: string;
    inputFieldStyle?: PropTypes.InferProps<typeof STYLES_PROP_TYPES>;
    inputFieldBorderType?: PropTypes.InferProps<typeof BORDER_TYPES_PROP_TYPES>;
    onCopyClick?: () => void;
    tooltipArrowLocation?: string;
    eventId?: string;
}

export class CopyField extends PureComponent<CopyFieldProps> {
    static defaultProps = {
        inputFieldBorderType: BORDER_SIMPLE,
    };

    render() {
        const {
            inputFieldId,
            inputFieldStyle,
            inputFieldBorderType,
            label,
            onCopyClick,
            tooltipArrowLocation,
            value,
        } = this.props;
        const suffix = (
            <CopyButtonWithTooltip
                onCopyClick={onCopyClick}
                value={value}
                tooltipId={`${inputFieldId}-tooltip`}
                tooltipArrowLocation={tooltipArrowLocation}
            />
        );

        return (
            <InputField
                id={inputFieldId}
                label={label}
                readOnly={true}
                style={inputFieldStyle}
                borderType={inputFieldBorderType}
                value={value}
                suffix={suffix}
                hasMinAsideSpacing={true}
            />
        );
    }
}
